import { create, StoreApi, UseBoundStore } from "zustand"; // Import StoreApi and UseBoundStore
import { devtools } from "zustand/middleware";

import {
  AssistantSlice,
  createAssistantSlice,
} from "./slices/assistantSlice";
import {
  createDomainIntegrationsSlice,
  DomainIntegrationsSlice,
} from "./slices/domainIntegrationsSlice";
import { createDomainSlice, DomainSlice } from "./slices/domainSlice";
import {
  createGoogleAnalyticsSlice,
  GoogleAnalyticsSlice,
} from "./slices/googleAnalyticsSlice";
import {
  createGoogleSearchConsoleSlice,
  GoogleSearchConsoleSlice,
} from "./slices/googleSearchConsoleSlice";
import { createHeaderSlice, HeaderSlice } from "./slices/headerSlice";
import { createJobsSlice, JobsSlice } from "./slices/jobsSlice";
import { createLibrarySlice, LibrarySlice } from "./slices/librarySlice";
import {
  createScheduledJobsSlice,
  ScheduledJobsSlice,
} from "./slices/scheduledJobsSlice";
import { createOfferSlice, OfferSlice } from "./slices/offerSlice";
import { createOrgSlice, OrgSlice } from "./slices/orgSlice";
import {
  createPageIntegrationsSlice,
  PageIntegrationsSlice,
} from "./slices/pageIntegrationsSlice";
import { createPageSlice, PageSlice } from "./slices/pageSlice";
import { createPersonaSlice, PersonaSlice } from "./slices/personaSlice";
import { createPolicySlice, PolicySlice } from "./slices/policySlice";
import { createUISlice, UISlice } from "./slices/uiSlice";
import { createAuthSlice, userSlice } from "./slices/userSlice";
import { createWordPressSlice, WordPressSlice } from "./slices/wordpressSlice";
import { createIdeaSlice, IdeaSlice } from "./slices/ideaSlice";

export type StoreState = userSlice &
  DomainSlice &
  DomainIntegrationsSlice &
  AssistantSlice &
  PageSlice &
  PageIntegrationsSlice &
  JobsSlice &
  LibrarySlice &
  ScheduledJobsSlice &
  HeaderSlice &
  PersonaSlice &
  OfferSlice &
  OrgSlice &
  PolicySlice &
  UISlice &
  GoogleAnalyticsSlice &
  GoogleSearchConsoleSlice &
  WordPressSlice &
  IdeaSlice;

// Define the store creator function with devtools applied
const storeInitializer = devtools<StoreState>((...a) => ({
  ...createAuthSlice(...a),
  ...createDomainSlice(...a),
  ...createDomainIntegrationsSlice(...a),
  ...createAssistantSlice(...a),
  ...createLibrarySlice(...a),
  ...createScheduledJobsSlice(...a),
  ...createJobsSlice(...a),
  ...createHeaderSlice(...a),
  ...createPageSlice(...a),
  ...createPageIntegrationsSlice(...a),
  ...createPersonaSlice(...a),
  ...createOfferSlice(...a),
  ...createOrgSlice(...a),
  ...createPolicySlice(...a),
  ...createUISlice(...a),
  ...createGoogleAnalyticsSlice(...a),
  ...createGoogleSearchConsoleSlice(...a),
  ...createWordPressSlice(...a),
  ...createIdeaSlice(...a),
}));

// Create the store and explicitly cast the hook type
export const useStore = create(storeInitializer) as UseBoundStore<
  StoreApi<StoreState>
>;
